// Floating contact menu: WhatsApp, Instagram, Phone
(function initContactMenu() {
  if (document.querySelector('.contact-fab')) return;

  const WA_NUMBER = '420773633433'; // digits only
  const EMAIL = 'prime.transfer2024@gmail.com';
  const INSTAGRAM_URL = 'https://www.instagram.com/prime.transfer2024';

  const container = document.createElement('div');
  container.className = 'contact-fab';

  container.innerHTML = `
    <button class="contact-fab__btn" aria-label="Contact menu" aria-expanded="false" aria-controls="contact-menu">
      <svg aria-hidden="true"><use href="/img/svg_meny_sprite.svg#icon-chat"></use></svg>
    </button>
    <nav id="contact-menu" class="contact-menu" aria-hidden="true" aria-label="Quick contacts">
      <ul class="contact-menu__list">
        <li class="contact-menu__item">
          <a class="contact-menu__link" href="https://wa.me/${WA_NUMBER}" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
            <span class="contact-menu__icon icon--whatsapp" aria-hidden="true">
              <img class="icon-img" src="/img/contact/whatsapp.png" alt="" width="32" height="32" />
              <svg class="icon-svg"><use href="/img/svg_meny_sprite.svg#icon-whatsapp-square-color"></use></svg>
            </span>
          </a>
        </li>
        <li class="contact-menu__item">
          <a class="contact-menu__link" href="${INSTAGRAM_URL}" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <span class="contact-menu__icon icon--instagram" aria-hidden="true">
              <img class="icon-img" src="/img/contact/instagram.png" alt="" width="32" height="32" />
              <svg class="icon-svg"><use href="/img/svg_meny_sprite.svg#icon-instagram-color"></use></svg>
            </span>
          </a>
        </li>
        <li class="contact-menu__item">
          <a class="contact-menu__link" href="mailto:${EMAIL}" aria-label="Email">
            <span class="contact-menu__icon icon--email" aria-hidden="true">
              <img class="icon-img" src="/img/contact/gmail.png" alt="" width="32" height="32" />
              <svg class="icon-svg"><use href="/img/svg_meny_sprite.svg#icon-email"></use></svg>
            </span>
          </a>
        </li>
      </ul>
    </nav>
  `;

  document.body.appendChild(container);

  const btn = container.querySelector('.contact-fab__btn');
  const panel = container.querySelector('#contact-menu');
  // Fallbacks: if PNG missing, show SVG instead
  function enablePngFallback(selector) {
    const holder = container.querySelector(selector);
    const img = holder ? holder.querySelector('.icon-img') : null;
    if (img) {
      img.addEventListener('error', () => holder.classList.add('no-png'));
      // If the image is cached-broken, force error by reassigning src
      if (img.complete && img.naturalWidth === 0)
        holder.classList.add('no-png');
    }
  }
  enablePngFallback('.icon--whatsapp');
  enablePngFallback('.icon--instagram');
  enablePngFallback('.icon--email');

  function openMenu() {
    container.classList.add('open');
    btn.setAttribute('aria-expanded', 'true');
    panel.setAttribute('aria-hidden', 'false');
  }
  function closeMenu() {
    container.classList.remove('open');
    btn.setAttribute('aria-expanded', 'false');
    panel.setAttribute('aria-hidden', 'true');
  }
  function toggleMenu() {
    if (container.classList.contains('open')) closeMenu();
    else openMenu();
  }

  btn.addEventListener('click', toggleMenu);

  // Close on outside click
  document.addEventListener('click', e => {
    if (!container.contains(e.target)) closeMenu();
  });

  // Close on Escape
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeMenu();
  });
})();
